import { ICheckboxEntry, ISubmissionReasonDto } from '@common/types';

export enum FileRoles {
  Original = 'original',
  Xml = 'xml',
  Html = 'html',
  ImageConversion = 'image-conversion',
  ImageUser = 'image-user',
  ErrorsXml = 'errors-xml',
  MigrationUnknown = 'migration-unknown',
  AlternativeText = 'alternative-text',
  PrimaryDocFile = 'primary-docfile',
  SecondaryPDFFile = 'secondary-pdffile',
  TvtFirstTvpFile = 'tvt-first-tvpfile',
  TvtSecondTvpFile = 'tvt-second-tvpfile',
  TvtPdfFile = 'tvt-pdffile',
  Notes = 'notes'
}

export type AddModalOpenModes = 'Add' | 'Update' | 'Replace' | null;

export interface IAddDocumentForm {
  documentId: number;
  documentTitle: string;
  file?: File;
  webLink?: string;
  hasDigitalVersion?: boolean;
  isCustomerApprovalRequired: boolean | null;
  includeSecondaryDocument: boolean | undefined;
  productIds: ICheckboxEntry[];
  content?: string;
  secondaryfile?: File;
  noAudioVideoUrl?: boolean;
}

export enum FormFields {
  documentId = 'documentId',
  documentTitle = 'documentTitle',
  file = 'file',
  webLink = 'webLink',
  hasDigitalVersion = 'hasDigitalVersion',
  isCustomerApprovalRequired = 'isCustomerApprovalRequired',
  productIds = 'productIds',
  content = 'content',
  secondaryfile = 'secondaryfile',
  includeSecondaryDocument = 'includeSecondaryDocument',
  noAudioVideoUrl = 'noAudioVideoUrl',
}

export enum ConversionErrorType {
  UnknownProblem = 'UnknownProblem',
  CorruptedFile = 'CorruptedFile',
  NestedTable = 'NestedTable',
  GridlessTable = 'GridlessTable',
  MissingImageAltText = 'MissingImageAltText',
}

export const conversionErrorTypeToCustomLabelMap: ConversionErrorTypToCustomLabel = {
  [ConversionErrorType.UnknownProblem]: 'We found an unknown problem',
  [ConversionErrorType.CorruptedFile]: 'Your file is corrupted',
  [ConversionErrorType.NestedTable]: 'Your document contains nested table',
  [ConversionErrorType.GridlessTable]: 'Your document contains gridless table',
};

type ConversionErrorTypToCustomLabel = {
  [key in string]?: string;
};

export enum RequestEpilQrdFormFields {
  file = 'file',
  isWithAlternativeText = 'isWithAlternativeText',
  alternativeTextFile = 'alternativeTextFile',
  alternativeTextFileName = 'alternativeTextFileName'
};

export enum RequestEpilStandardFormFields {
  isWithAlternativeText = 'isWithAlternativeText',
  alternativeTextFile = 'alternativeTextFile',
  alternativeTextFileName = 'alternativeTextFileName'
};

export enum DocumentVisibility
{
	visibleToAll = 'visibleToAll',
	visibleToHealthcare = 'visibleToHealthcare'
}

export interface IPostPublicationChangeDto {
  date: Date;
  code: number;
}

export interface IDocumentMetadataDto {
  documentId: number;
  documentType: DocumentType;
  isRetired: boolean;
  title : string;
  version: string;
  fileName?: string;
  webLink?: string;
  regulator?: string;
  submittedDate: Date;
  statusChangeDate: Date;
  regulatorApprovalDate?: Date;
  authorisedDate?: Date;
  documentApprovedDate?: Date;
  submissionReasons: ISubmissionReasonDto[];
  retireReason?: ISubmissionReasonDto;
  postPublicationChanges: IPostPublicationChangeDto[];
  visibility?: DocumentVisibility;
  documentDescription?: string;
  changeDetails?: string;
  hasTvtFiles?: string;
}